import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="#EAEBEC" d="M24 12a12 12 0 11-24 0 12 12 0 0124 0zM3.6 12a8.4 8.4 0 1016.8 0 8.4 8.4 0 00-16.8 0z"/>
    <path fill="#34CEFF" d="M24 12a12 12 0 01-8.3 11.41L14.6 20A8.4 8.4 0 0020.4 12H24z"/>
  </SvgIcon>
);